export function validarTelefono(telefono) {
    return /^[679]{1}[0-9]{8}$/.test(telefono);
}